import axios from 'axios';

const ApiService = axios.create({
    // baseURL: 'http://localhost:4000',
    // baseURL: 'https://bssa-db.vercel.app',
    // baseURL: 'https://bssa-database.vercel.app',// this is the currently api
    // baseURL: 'https://bssa-json-server-vercel-deployment.vercel.app/',
    // baseURL: 'https://bssa-db-vercel.vercel.app/',
    baseURL: "https://api.biharsports.org/contents/",
    // timeout: 10000, // optional timeout
    headers: {
        'Content-Type': 'application/json', // Set default headers if needed
    },
});

export default ApiService;
